import React from "react";
import GenericDrawer from "./GenericDrawer";
import HamburgerMenuMobile from "../MenuV2/HamburgerMenuMobile";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../redux/selectors";
import { useDispatch } from "react-redux";
import { useClickOutside, useNoScroll } from "../../hooks";
import { MenuActionCreators } from "../../redux/action-creators";
import { DrawerType, VerticalTransition } from "../../constants";
import MobileDrawerHeader from "../MenuV2/MobileDrawerHeader";

const HamburgerDrawer = function () {
  const dispatch = useDispatch();

  const hamburgerMenuVisible = useSelector(MenuSelectors.hamburgerMenuVisible);

  const drawerRef = useClickOutside(
    () => {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    },
    {
      disabled: !hamburgerMenuVisible
    }
  );
  useNoScroll("hamburgerDrawer", hamburgerMenuVisible);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      isVisible={hamburgerMenuVisible}
      menu={DrawerType.HamburgerMenu}
      hasFavoriteSport={true}
      header={<MobileDrawerHeader menu={DrawerType.HamburgerMenu} />}
      className="hamburger-drawer"
      verticalTransition={VerticalTransition.Left}
    >
      <HamburgerMenuMobile />
    </GenericDrawer>
  );
};

export default React.memo(HamburgerDrawer);
